import { render, staticRenderFns } from "./SurveyNav.vue?vue&type=template&id=8ebb95f8&scoped=true"
import script from "./SurveyNav.vue?vue&type=script&lang=js"
export * from "./SurveyNav.vue?vue&type=script&lang=js"
import style0 from "./SurveyNav.vue?vue&type=style&index=0&id=8ebb95f8&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebb95f8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/sbsdevops/devops/jenkins-slave/workspace/bizbize-frontend-dev/xpermeet-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8ebb95f8')) {
      api.createRecord('8ebb95f8', component.options)
    } else {
      api.reload('8ebb95f8', component.options)
    }
    module.hot.accept("./SurveyNav.vue?vue&type=template&id=8ebb95f8&scoped=true", function () {
      api.rerender('8ebb95f8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Survey/SurveyNav.vue"
export default component.exports